import createIcon from '../../createIcon';

/**
 * @component @name BrightnessAuto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMDY2MCkiPgo8cGF0aCBkPSJNMTAuODUwNCAxMi42NTA0SDEzLjE1MDRMMTIuMDAwNCA5LjAwMDQzTDEwLjg1MDQgMTIuNjUwNFpNMjAuMDAwNCA4LjY5MDQzVjQuMDAwNDNIMTUuMzEwNEwxMi4wMDA0IDAuNjkwNDNMOC42OTA0MyA0LjAwMDQzSDQuMDAwNDNWOC42OTA0M0wwLjY5MDQzIDEyLjAwMDRMNC4wMDA0MyAxNS4zMTA0VjIwLjAwMDRIOC42OTA0M0wxMi4wMDA0IDIzLjMxMDRMMTUuMzEwNCAyMC4wMDA0SDIwLjAwMDRWMTUuMzEwNEwyMy4zMTA0IDEyLjAwMDRMMjAuMDAwNCA4LjY5MDQzWk0xNC4zMDA0IDE2LjAwMDRMMTMuNjAwNCAxNC4wMDA0SDEwLjQwMDRMOS43MDA0MyAxNi4wMDA0SDcuODAwNDNMMTEuMDAwNCA3LjAwMDQzSDEzLjAwMDRMMTYuMjAwNCAxNi4wMDA0SDE0LjMwMDRaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI0MDJfMjA2NjAiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrightnessAuto = createIcon('BrightnessAuto', [
  ['g', { clipPath: 'url(#clip0_2402_20660)', key: '194inc' }],
  ['defs', { key: '9ahrjx' }],
]);

export default BrightnessAuto;
